/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppMoreRouteImport } from './routes/_app.more'
import { Route as AppNotificationsRouteImport } from './routes/_app.notifications'
import { Route as AppSearchRouteImport } from './routes/_app.search'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppTodayRouteImport } from './routes/_app.today'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as SetupPasskeyRouteImport } from './routes/setup.passkey'
import { Route as SignInIndexRouteImport } from './routes/sign-in.index'
import { Route as SignInVerifyRouteImport } from './routes/sign-in.verify'
import { Route as AppAssetsIndexRouteImport } from './routes/_app.assets.index'
import { Route as AppAssetsNewRouteImport } from './routes/_app.assets.new'
import { Route as AppCalendarIndexRouteImport } from './routes/_app.calendar.index'
import { Route as AppContractsIndexRouteImport } from './routes/_app.contracts.index'
import { Route as AppCostsIndexRouteImport } from './routes/_app.costs.index'
import { Route as AppDocumentsIndexRouteImport } from './routes/_app.documents.index'
import { Route as AppDocumentsIdRouteImport } from './routes/_app.documents.$id'
import { Route as AppListsIndexRouteImport } from './routes/_app.lists.index'
import { Route as AppListsIdRouteImport } from './routes/_app.lists.$id'
import { Route as AppLogbookIndexRouteImport } from './routes/_app.logbook.index'
import { Route as AppLogbookIdRouteImport } from './routes/_app.logbook.$id'
import { Route as AppManualIndexRouteImport } from './routes/_app.manual.index'
import { Route as AppManualPageIdRouteImport } from './routes/_app.manual.$pageId'
import { Route as AppManualImportRouteImport } from './routes/_app.manual.import'
import { Route as AppOrganizationsIdRouteImport } from './routes/_app.organizations.$id'
import { Route as AppPeopleIndexRouteImport } from './routes/_app.people.index'
import { Route as AppPlanningIndexRouteImport } from './routes/_app.planning.index'
import { Route as AppProjectsIndexRouteImport } from './routes/_app.projects.index'
import { Route as AppPropertiesIndexRouteImport } from './routes/_app.properties.index'
import { Route as AppPropertiesNewRouteImport } from './routes/_app.properties.new'
import { Route as AppSettingsIndexRouteImport } from './routes/_app.settings.index'
import { Route as AppSettingsSectionRouteImport } from './routes/_app.settings.$section'
import { Route as AppTasksIndexRouteImport } from './routes/_app.tasks.index'
import { Route as AppTasksIdRouteImport } from './routes/_app.tasks.$id'
import { Route as AppVaultIndexRouteImport } from './routes/_app.vault.index'
import { Route as AppVaultIdRouteImport } from './routes/_app.vault.$id'
import { Route as AppAssetsIdChar123TabChar125RouteImport } from './routes/_app.assets.$id.{-$tab}'
import { Route as AppCalendarEventsIdRouteImport } from './routes/_app.calendar.events.$id'
import { Route as AppContractsIdChar123TabChar125RouteImport } from './routes/_app.contracts.$id.{-$tab}'
import { Route as AppListsTemplatesIndexRouteImport } from './routes/_app.lists.templates.index'
import { Route as AppListsTemplatesIdRouteImport } from './routes/_app.lists.templates.$id'
import { Route as AppPeopleIdChar123TabChar125RouteImport } from './routes/_app.people.$id.{-$tab}'
import { Route as AppProjectsIdChar123TabChar125RouteImport } from './routes/_app.projects.$id.{-$tab}'
import { Route as AppPropertiesIdChar123TabChar125RouteImport } from './routes/_app.properties.$id.{-$tab}'
import { Route as AppTasksSeriesIdRouteImport } from './routes/_app.tasks.series.$id'
import { Route as AppPropertiesIdZonesZoneIdRouteImport } from './routes/_app.properties.$id.zones.$zoneId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMoreRoute = AppMoreRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTodayRoute = AppTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AppRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupPasskeyRoute = SetupPasskeyRouteImport.update({
  id: '/setup/passkey',
  path: '/setup/passkey',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInIndexRoute = SignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInVerifyRoute = SignInVerifyRouteImport.update({
  id: '/sign-in/verify',
  path: '/sign-in/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAssetsIndexRoute = AppAssetsIndexRouteImport.update({
  id: '/assets/',
  path: '/assets/',
  getParentRoute: () => AppRoute,
} as any)
const AppAssetsNewRoute = AppAssetsNewRouteImport.update({
  id: '/assets/new',
  path: '/assets/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarIndexRoute = AppCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => AppRoute,
} as any)
const AppContractsIndexRoute = AppContractsIndexRouteImport.update({
  id: '/contracts/',
  path: '/contracts/',
  getParentRoute: () => AppRoute,
} as any)
const AppCostsIndexRoute = AppCostsIndexRouteImport.update({
  id: '/costs/',
  path: '/costs/',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsIndexRoute = AppDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsIdRoute = AppDocumentsIdRouteImport.update({
  id: '/documents/$id',
  path: '/documents/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppListsIndexRoute = AppListsIndexRouteImport.update({
  id: '/lists/',
  path: '/lists/',
  getParentRoute: () => AppRoute,
} as any)
const AppListsIdRoute = AppListsIdRouteImport.update({
  id: '/lists/$id',
  path: '/lists/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppLogbookIndexRoute = AppLogbookIndexRouteImport.update({
  id: '/logbook/',
  path: '/logbook/',
  getParentRoute: () => AppRoute,
} as any)
const AppLogbookIdRoute = AppLogbookIdRouteImport.update({
  id: '/logbook/$id',
  path: '/logbook/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppManualIndexRoute = AppManualIndexRouteImport.update({
  id: '/manual/',
  path: '/manual/',
  getParentRoute: () => AppRoute,
} as any)
const AppManualPageIdRoute = AppManualPageIdRouteImport.update({
  id: '/manual/$pageId',
  path: '/manual/$pageId',
  getParentRoute: () => AppRoute,
} as any)
const AppManualImportRoute = AppManualImportRouteImport.update({
  id: '/manual/import',
  path: '/manual/import',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizationsIdRoute = AppOrganizationsIdRouteImport.update({
  id: '/organizations/$id',
  path: '/organizations/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPeopleIndexRoute = AppPeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanningIndexRoute = AppPlanningIndexRouteImport.update({
  id: '/planning/',
  path: '/planning/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesIndexRoute = AppPropertiesIndexRouteImport.update({
  id: '/properties/',
  path: '/properties/',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesNewRoute = AppPropertiesNewRouteImport.update({
  id: '/properties/new',
  path: '/properties/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSectionRoute = AppSettingsSectionRouteImport.update({
  id: '/$section',
  path: '/$section',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppTasksIndexRoute = AppTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksIdRoute = AppTasksIdRouteImport.update({
  id: '/tasks/$id',
  path: '/tasks/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppVaultIndexRoute = AppVaultIndexRouteImport.update({
  id: '/vault/',
  path: '/vault/',
  getParentRoute: () => AppRoute,
} as any)
const AppVaultIdRoute = AppVaultIdRouteImport.update({
  id: '/vault/$id',
  path: '/vault/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAssetsIdChar123TabChar125Route =
  AppAssetsIdChar123TabChar125RouteImport.update({
    id: '/assets/$id/{-$tab}',
    path: '/assets/$id/{-$tab}',
    getParentRoute: () => AppRoute,
  } as any)
const AppCalendarEventsIdRoute = AppCalendarEventsIdRouteImport.update({
  id: '/calendar/events/$id',
  path: '/calendar/events/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppContractsIdChar123TabChar125Route =
  AppContractsIdChar123TabChar125RouteImport.update({
    id: '/contracts/$id/{-$tab}',
    path: '/contracts/$id/{-$tab}',
    getParentRoute: () => AppRoute,
  } as any)
const AppListsTemplatesIndexRoute = AppListsTemplatesIndexRouteImport.update({
  id: '/lists/templates/',
  path: '/lists/templates/',
  getParentRoute: () => AppRoute,
} as any)
const AppListsTemplatesIdRoute = AppListsTemplatesIdRouteImport.update({
  id: '/lists/templates/$id',
  path: '/lists/templates/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPeopleIdChar123TabChar125Route =
  AppPeopleIdChar123TabChar125RouteImport.update({
    id: '/people/$id/{-$tab}',
    path: '/people/$id/{-$tab}',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsIdChar123TabChar125Route =
  AppProjectsIdChar123TabChar125RouteImport.update({
    id: '/projects/$id/{-$tab}',
    path: '/projects/$id/{-$tab}',
    getParentRoute: () => AppRoute,
  } as any)
const AppPropertiesIdChar123TabChar125Route =
  AppPropertiesIdChar123TabChar125RouteImport.update({
    id: '/properties/$id/{-$tab}',
    path: '/properties/$id/{-$tab}',
    getParentRoute: () => AppRoute,
  } as any)
const AppTasksSeriesIdRoute = AppTasksSeriesIdRouteImport.update({
  id: '/tasks/series/$id',
  path: '/tasks/series/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesIdZonesZoneIdRoute =
  AppPropertiesIdZonesZoneIdRouteImport.update({
    id: '/properties/$id/zones/$zoneId',
    path: '/properties/$id/zones/$zoneId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/more': typeof AppMoreRoute
  '/notifications': typeof AppNotificationsRoute
  '/search': typeof AppSearchRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/today': typeof AppTodayRoute
  '/invite/$token': typeof InviteTokenRoute
  '/s/$token': typeof STokenRoute
  '/setup/passkey': typeof SetupPasskeyRoute
  '/sign-in/verify': typeof SignInVerifyRoute
  '/sign-in/': typeof SignInIndexRoute
  '/assets/new': typeof AppAssetsNewRoute
  '/documents/$id': typeof AppDocumentsIdRoute
  '/lists/$id': typeof AppListsIdRoute
  '/logbook/$id': typeof AppLogbookIdRoute
  '/manual/$pageId': typeof AppManualPageIdRoute
  '/manual/import': typeof AppManualImportRoute
  '/organizations/$id': typeof AppOrganizationsIdRoute
  '/properties/new': typeof AppPropertiesNewRoute
  '/settings/$section': typeof AppSettingsSectionRoute
  '/tasks/$id': typeof AppTasksIdRoute
  '/vault/$id': typeof AppVaultIdRoute
  '/assets/': typeof AppAssetsIndexRoute
  '/calendar/': typeof AppCalendarIndexRoute
  '/contracts/': typeof AppContractsIndexRoute
  '/costs/': typeof AppCostsIndexRoute
  '/documents/': typeof AppDocumentsIndexRoute
  '/lists/': typeof AppListsIndexRoute
  '/logbook/': typeof AppLogbookIndexRoute
  '/manual/': typeof AppManualIndexRoute
  '/people/': typeof AppPeopleIndexRoute
  '/planning/': typeof AppPlanningIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/properties/': typeof AppPropertiesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/tasks/': typeof AppTasksIndexRoute
  '/vault/': typeof AppVaultIndexRoute
  '/assets/$id/{-$tab}': typeof AppAssetsIdChar123TabChar125Route
  '/calendar/events/$id': typeof AppCalendarEventsIdRoute
  '/contracts/$id/{-$tab}': typeof AppContractsIdChar123TabChar125Route
  '/lists/templates/$id': typeof AppListsTemplatesIdRoute
  '/people/$id/{-$tab}': typeof AppPeopleIdChar123TabChar125Route
  '/projects/$id/{-$tab}': typeof AppProjectsIdChar123TabChar125Route
  '/properties/$id/{-$tab}': typeof AppPropertiesIdChar123TabChar125Route
  '/tasks/series/$id': typeof AppTasksSeriesIdRoute
  '/lists/templates/': typeof AppListsTemplatesIndexRoute
  '/properties/$id/zones/$zoneId': typeof AppPropertiesIdZonesZoneIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/more': typeof AppMoreRoute
  '/notifications': typeof AppNotificationsRoute
  '/search': typeof AppSearchRoute
  '/today': typeof AppTodayRoute
  '/invite/$token': typeof InviteTokenRoute
  '/s/$token': typeof STokenRoute
  '/setup/passkey': typeof SetupPasskeyRoute
  '/sign-in/verify': typeof SignInVerifyRoute
  '/sign-in': typeof SignInIndexRoute
  '/assets/new': typeof AppAssetsNewRoute
  '/documents/$id': typeof AppDocumentsIdRoute
  '/lists/$id': typeof AppListsIdRoute
  '/logbook/$id': typeof AppLogbookIdRoute
  '/manual/$pageId': typeof AppManualPageIdRoute
  '/manual/import': typeof AppManualImportRoute
  '/organizations/$id': typeof AppOrganizationsIdRoute
  '/properties/new': typeof AppPropertiesNewRoute
  '/settings/$section': typeof AppSettingsSectionRoute
  '/tasks/$id': typeof AppTasksIdRoute
  '/vault/$id': typeof AppVaultIdRoute
  '/assets': typeof AppAssetsIndexRoute
  '/calendar': typeof AppCalendarIndexRoute
  '/contracts': typeof AppContractsIndexRoute
  '/costs': typeof AppCostsIndexRoute
  '/documents': typeof AppDocumentsIndexRoute
  '/lists': typeof AppListsIndexRoute
  '/logbook': typeof AppLogbookIndexRoute
  '/manual': typeof AppManualIndexRoute
  '/people': typeof AppPeopleIndexRoute
  '/planning': typeof AppPlanningIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/properties': typeof AppPropertiesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/tasks': typeof AppTasksIndexRoute
  '/vault': typeof AppVaultIndexRoute
  '/assets/$id/{-$tab}': typeof AppAssetsIdChar123TabChar125Route
  '/calendar/events/$id': typeof AppCalendarEventsIdRoute
  '/contracts/$id/{-$tab}': typeof AppContractsIdChar123TabChar125Route
  '/lists/templates/$id': typeof AppListsTemplatesIdRoute
  '/people/$id/{-$tab}': typeof AppPeopleIdChar123TabChar125Route
  '/projects/$id/{-$tab}': typeof AppProjectsIdChar123TabChar125Route
  '/properties/$id/{-$tab}': typeof AppPropertiesIdChar123TabChar125Route
  '/tasks/series/$id': typeof AppTasksSeriesIdRoute
  '/lists/templates': typeof AppListsTemplatesIndexRoute
  '/properties/$id/zones/$zoneId': typeof AppPropertiesIdZonesZoneIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_app/more': typeof AppMoreRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/search': typeof AppSearchRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/today': typeof AppTodayRoute
  '/invite/$token': typeof InviteTokenRoute
  '/s/$token': typeof STokenRoute
  '/setup/passkey': typeof SetupPasskeyRoute
  '/sign-in/verify': typeof SignInVerifyRoute
  '/sign-in/': typeof SignInIndexRoute
  '/_app/assets/new': typeof AppAssetsNewRoute
  '/_app/documents/$id': typeof AppDocumentsIdRoute
  '/_app/lists/$id': typeof AppListsIdRoute
  '/_app/logbook/$id': typeof AppLogbookIdRoute
  '/_app/manual/$pageId': typeof AppManualPageIdRoute
  '/_app/manual/import': typeof AppManualImportRoute
  '/_app/organizations/$id': typeof AppOrganizationsIdRoute
  '/_app/properties/new': typeof AppPropertiesNewRoute
  '/_app/settings/$section': typeof AppSettingsSectionRoute
  '/_app/tasks/$id': typeof AppTasksIdRoute
  '/_app/vault/$id': typeof AppVaultIdRoute
  '/_app/assets/': typeof AppAssetsIndexRoute
  '/_app/calendar/': typeof AppCalendarIndexRoute
  '/_app/contracts/': typeof AppContractsIndexRoute
  '/_app/costs/': typeof AppCostsIndexRoute
  '/_app/documents/': typeof AppDocumentsIndexRoute
  '/_app/lists/': typeof AppListsIndexRoute
  '/_app/logbook/': typeof AppLogbookIndexRoute
  '/_app/manual/': typeof AppManualIndexRoute
  '/_app/people/': typeof AppPeopleIndexRoute
  '/_app/planning/': typeof AppPlanningIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/properties/': typeof AppPropertiesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/tasks/': typeof AppTasksIndexRoute
  '/_app/vault/': typeof AppVaultIndexRoute
  '/_app/assets/$id/{-$tab}': typeof AppAssetsIdChar123TabChar125Route
  '/_app/calendar/events/$id': typeof AppCalendarEventsIdRoute
  '/_app/contracts/$id/{-$tab}': typeof AppContractsIdChar123TabChar125Route
  '/_app/lists/templates/$id': typeof AppListsTemplatesIdRoute
  '/_app/people/$id/{-$tab}': typeof AppPeopleIdChar123TabChar125Route
  '/_app/projects/$id/{-$tab}': typeof AppProjectsIdChar123TabChar125Route
  '/_app/properties/$id/{-$tab}': typeof AppPropertiesIdChar123TabChar125Route
  '/_app/tasks/series/$id': typeof AppTasksSeriesIdRoute
  '/_app/lists/templates/': typeof AppListsTemplatesIndexRoute
  '/_app/properties/$id/zones/$zoneId': typeof AppPropertiesIdZonesZoneIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/more'
    | '/notifications'
    | '/search'
    | '/settings'
    | '/today'
    | '/invite/$token'
    | '/s/$token'
    | '/setup/passkey'
    | '/sign-in/verify'
    | '/sign-in/'
    | '/assets/new'
    | '/documents/$id'
    | '/lists/$id'
    | '/logbook/$id'
    | '/manual/$pageId'
    | '/manual/import'
    | '/organizations/$id'
    | '/properties/new'
    | '/settings/$section'
    | '/tasks/$id'
    | '/vault/$id'
    | '/assets/'
    | '/calendar/'
    | '/contracts/'
    | '/costs/'
    | '/documents/'
    | '/lists/'
    | '/logbook/'
    | '/manual/'
    | '/people/'
    | '/planning/'
    | '/projects/'
    | '/properties/'
    | '/settings/'
    | '/tasks/'
    | '/vault/'
    | '/assets/$id/{-$tab}'
    | '/calendar/events/$id'
    | '/contracts/$id/{-$tab}'
    | '/lists/templates/$id'
    | '/people/$id/{-$tab}'
    | '/projects/$id/{-$tab}'
    | '/properties/$id/{-$tab}'
    | '/tasks/series/$id'
    | '/lists/templates/'
    | '/properties/$id/zones/$zoneId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/more'
    | '/notifications'
    | '/search'
    | '/today'
    | '/invite/$token'
    | '/s/$token'
    | '/setup/passkey'
    | '/sign-in/verify'
    | '/sign-in'
    | '/assets/new'
    | '/documents/$id'
    | '/lists/$id'
    | '/logbook/$id'
    | '/manual/$pageId'
    | '/manual/import'
    | '/organizations/$id'
    | '/properties/new'
    | '/settings/$section'
    | '/tasks/$id'
    | '/vault/$id'
    | '/assets'
    | '/calendar'
    | '/contracts'
    | '/costs'
    | '/documents'
    | '/lists'
    | '/logbook'
    | '/manual'
    | '/people'
    | '/planning'
    | '/projects'
    | '/properties'
    | '/settings'
    | '/tasks'
    | '/vault'
    | '/assets/$id/{-$tab}'
    | '/calendar/events/$id'
    | '/contracts/$id/{-$tab}'
    | '/lists/templates/$id'
    | '/people/$id/{-$tab}'
    | '/projects/$id/{-$tab}'
    | '/properties/$id/{-$tab}'
    | '/tasks/series/$id'
    | '/lists/templates'
    | '/properties/$id/zones/$zoneId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_app/more'
    | '/_app/notifications'
    | '/_app/search'
    | '/_app/settings'
    | '/_app/today'
    | '/invite/$token'
    | '/s/$token'
    | '/setup/passkey'
    | '/sign-in/verify'
    | '/sign-in/'
    | '/_app/assets/new'
    | '/_app/documents/$id'
    | '/_app/lists/$id'
    | '/_app/logbook/$id'
    | '/_app/manual/$pageId'
    | '/_app/manual/import'
    | '/_app/organizations/$id'
    | '/_app/properties/new'
    | '/_app/settings/$section'
    | '/_app/tasks/$id'
    | '/_app/vault/$id'
    | '/_app/assets/'
    | '/_app/calendar/'
    | '/_app/contracts/'
    | '/_app/costs/'
    | '/_app/documents/'
    | '/_app/lists/'
    | '/_app/logbook/'
    | '/_app/manual/'
    | '/_app/people/'
    | '/_app/planning/'
    | '/_app/projects/'
    | '/_app/properties/'
    | '/_app/settings/'
    | '/_app/tasks/'
    | '/_app/vault/'
    | '/_app/assets/$id/{-$tab}'
    | '/_app/calendar/events/$id'
    | '/_app/contracts/$id/{-$tab}'
    | '/_app/lists/templates/$id'
    | '/_app/people/$id/{-$tab}'
    | '/_app/projects/$id/{-$tab}'
    | '/_app/properties/$id/{-$tab}'
    | '/_app/tasks/series/$id'
    | '/_app/lists/templates/'
    | '/_app/properties/$id/zones/$zoneId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  InviteTokenRoute: typeof InviteTokenRoute
  STokenRoute: typeof STokenRoute
  SetupPasskeyRoute: typeof SetupPasskeyRoute
  SignInVerifyRoute: typeof SignInVerifyRoute
  SignInIndexRoute: typeof SignInIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/more': {
      id: '/_app/more'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof AppMoreRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/today': {
      id: '/_app/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AppTodayRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup/passkey': {
      id: '/setup/passkey'
      path: '/setup/passkey'
      fullPath: '/setup/passkey'
      preLoaderRoute: typeof SetupPasskeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/': {
      id: '/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in/'
      preLoaderRoute: typeof SignInIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/verify': {
      id: '/sign-in/verify'
      path: '/sign-in/verify'
      fullPath: '/sign-in/verify'
      preLoaderRoute: typeof SignInVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/assets/': {
      id: '/_app/assets/'
      path: '/assets'
      fullPath: '/assets/'
      preLoaderRoute: typeof AppAssetsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/assets/new': {
      id: '/_app/assets/new'
      path: '/assets/new'
      fullPath: '/assets/new'
      preLoaderRoute: typeof AppAssetsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar/': {
      id: '/_app/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof AppCalendarIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contracts/': {
      id: '/_app/contracts/'
      path: '/contracts'
      fullPath: '/contracts/'
      preLoaderRoute: typeof AppContractsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/costs/': {
      id: '/_app/costs/'
      path: '/costs'
      fullPath: '/costs/'
      preLoaderRoute: typeof AppCostsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/': {
      id: '/_app/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AppDocumentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/$id': {
      id: '/_app/documents/$id'
      path: '/documents/$id'
      fullPath: '/documents/$id'
      preLoaderRoute: typeof AppDocumentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lists/': {
      id: '/_app/lists/'
      path: '/lists'
      fullPath: '/lists/'
      preLoaderRoute: typeof AppListsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lists/$id': {
      id: '/_app/lists/$id'
      path: '/lists/$id'
      fullPath: '/lists/$id'
      preLoaderRoute: typeof AppListsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logbook/': {
      id: '/_app/logbook/'
      path: '/logbook'
      fullPath: '/logbook/'
      preLoaderRoute: typeof AppLogbookIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logbook/$id': {
      id: '/_app/logbook/$id'
      path: '/logbook/$id'
      fullPath: '/logbook/$id'
      preLoaderRoute: typeof AppLogbookIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manual/': {
      id: '/_app/manual/'
      path: '/manual'
      fullPath: '/manual/'
      preLoaderRoute: typeof AppManualIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manual/$pageId': {
      id: '/_app/manual/$pageId'
      path: '/manual/$pageId'
      fullPath: '/manual/$pageId'
      preLoaderRoute: typeof AppManualPageIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/manual/import': {
      id: '/_app/manual/import'
      path: '/manual/import'
      fullPath: '/manual/import'
      preLoaderRoute: typeof AppManualImportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizations/$id': {
      id: '/_app/organizations/$id'
      path: '/organizations/$id'
      fullPath: '/organizations/$id'
      preLoaderRoute: typeof AppOrganizationsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/people/': {
      id: '/_app/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof AppPeopleIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/planning/': {
      id: '/_app/planning/'
      path: '/planning'
      fullPath: '/planning/'
      preLoaderRoute: typeof AppPlanningIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/': {
      id: '/_app/properties/'
      path: '/properties'
      fullPath: '/properties/'
      preLoaderRoute: typeof AppPropertiesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/new': {
      id: '/_app/properties/new'
      path: '/properties/new'
      fullPath: '/properties/new'
      preLoaderRoute: typeof AppPropertiesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/$section': {
      id: '/_app/settings/$section'
      path: '/$section'
      fullPath: '/settings/$section'
      preLoaderRoute: typeof AppSettingsSectionRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/tasks/': {
      id: '/_app/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AppTasksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks/$id': {
      id: '/_app/tasks/$id'
      path: '/tasks/$id'
      fullPath: '/tasks/$id'
      preLoaderRoute: typeof AppTasksIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vault/': {
      id: '/_app/vault/'
      path: '/vault'
      fullPath: '/vault/'
      preLoaderRoute: typeof AppVaultIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vault/$id': {
      id: '/_app/vault/$id'
      path: '/vault/$id'
      fullPath: '/vault/$id'
      preLoaderRoute: typeof AppVaultIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/assets/$id/{-$tab}': {
      id: '/_app/assets/$id/{-$tab}'
      path: '/assets/$id/{-$tab}'
      fullPath: '/assets/$id/{-$tab}'
      preLoaderRoute: typeof AppAssetsIdChar123TabChar125RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar/events/$id': {
      id: '/_app/calendar/events/$id'
      path: '/calendar/events/$id'
      fullPath: '/calendar/events/$id'
      preLoaderRoute: typeof AppCalendarEventsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contracts/$id/{-$tab}': {
      id: '/_app/contracts/$id/{-$tab}'
      path: '/contracts/$id/{-$tab}'
      fullPath: '/contracts/$id/{-$tab}'
      preLoaderRoute: typeof AppContractsIdChar123TabChar125RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lists/templates/': {
      id: '/_app/lists/templates/'
      path: '/lists/templates'
      fullPath: '/lists/templates/'
      preLoaderRoute: typeof AppListsTemplatesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lists/templates/$id': {
      id: '/_app/lists/templates/$id'
      path: '/lists/templates/$id'
      fullPath: '/lists/templates/$id'
      preLoaderRoute: typeof AppListsTemplatesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/people/$id/{-$tab}': {
      id: '/_app/people/$id/{-$tab}'
      path: '/people/$id/{-$tab}'
      fullPath: '/people/$id/{-$tab}'
      preLoaderRoute: typeof AppPeopleIdChar123TabChar125RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id/{-$tab}': {
      id: '/_app/projects/$id/{-$tab}'
      path: '/projects/$id/{-$tab}'
      fullPath: '/projects/$id/{-$tab}'
      preLoaderRoute: typeof AppProjectsIdChar123TabChar125RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/$id/{-$tab}': {
      id: '/_app/properties/$id/{-$tab}'
      path: '/properties/$id/{-$tab}'
      fullPath: '/properties/$id/{-$tab}'
      preLoaderRoute: typeof AppPropertiesIdChar123TabChar125RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks/series/$id': {
      id: '/_app/tasks/series/$id'
      path: '/tasks/series/$id'
      fullPath: '/tasks/series/$id'
      preLoaderRoute: typeof AppTasksSeriesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/$id/zones/$zoneId': {
      id: '/_app/properties/$id/zones/$zoneId'
      path: '/properties/$id/zones/$zoneId'
      fullPath: '/properties/$id/zones/$zoneId'
      preLoaderRoute: typeof AppPropertiesIdZonesZoneIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsSectionRoute: typeof AppSettingsSectionRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsSectionRoute: AppSettingsSectionRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppMoreRoute: typeof AppMoreRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppTodayRoute: typeof AppTodayRoute
  AppAssetsNewRoute: typeof AppAssetsNewRoute
  AppDocumentsIdRoute: typeof AppDocumentsIdRoute
  AppListsIdRoute: typeof AppListsIdRoute
  AppLogbookIdRoute: typeof AppLogbookIdRoute
  AppManualPageIdRoute: typeof AppManualPageIdRoute
  AppManualImportRoute: typeof AppManualImportRoute
  AppOrganizationsIdRoute: typeof AppOrganizationsIdRoute
  AppPropertiesNewRoute: typeof AppPropertiesNewRoute
  AppTasksIdRoute: typeof AppTasksIdRoute
  AppVaultIdRoute: typeof AppVaultIdRoute
  AppAssetsIndexRoute: typeof AppAssetsIndexRoute
  AppCalendarIndexRoute: typeof AppCalendarIndexRoute
  AppContractsIndexRoute: typeof AppContractsIndexRoute
  AppCostsIndexRoute: typeof AppCostsIndexRoute
  AppDocumentsIndexRoute: typeof AppDocumentsIndexRoute
  AppListsIndexRoute: typeof AppListsIndexRoute
  AppLogbookIndexRoute: typeof AppLogbookIndexRoute
  AppManualIndexRoute: typeof AppManualIndexRoute
  AppPeopleIndexRoute: typeof AppPeopleIndexRoute
  AppPlanningIndexRoute: typeof AppPlanningIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppPropertiesIndexRoute: typeof AppPropertiesIndexRoute
  AppTasksIndexRoute: typeof AppTasksIndexRoute
  AppVaultIndexRoute: typeof AppVaultIndexRoute
  AppAssetsIdChar123TabChar125Route: typeof AppAssetsIdChar123TabChar125Route
  AppCalendarEventsIdRoute: typeof AppCalendarEventsIdRoute
  AppContractsIdChar123TabChar125Route: typeof AppContractsIdChar123TabChar125Route
  AppListsTemplatesIdRoute: typeof AppListsTemplatesIdRoute
  AppPeopleIdChar123TabChar125Route: typeof AppPeopleIdChar123TabChar125Route
  AppProjectsIdChar123TabChar125Route: typeof AppProjectsIdChar123TabChar125Route
  AppPropertiesIdChar123TabChar125Route: typeof AppPropertiesIdChar123TabChar125Route
  AppTasksSeriesIdRoute: typeof AppTasksSeriesIdRoute
  AppListsTemplatesIndexRoute: typeof AppListsTemplatesIndexRoute
  AppPropertiesIdZonesZoneIdRoute: typeof AppPropertiesIdZonesZoneIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppMoreRoute: AppMoreRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppSearchRoute: AppSearchRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppTodayRoute: AppTodayRoute,
  AppAssetsNewRoute: AppAssetsNewRoute,
  AppDocumentsIdRoute: AppDocumentsIdRoute,
  AppListsIdRoute: AppListsIdRoute,
  AppLogbookIdRoute: AppLogbookIdRoute,
  AppManualPageIdRoute: AppManualPageIdRoute,
  AppManualImportRoute: AppManualImportRoute,
  AppOrganizationsIdRoute: AppOrganizationsIdRoute,
  AppPropertiesNewRoute: AppPropertiesNewRoute,
  AppTasksIdRoute: AppTasksIdRoute,
  AppVaultIdRoute: AppVaultIdRoute,
  AppAssetsIndexRoute: AppAssetsIndexRoute,
  AppCalendarIndexRoute: AppCalendarIndexRoute,
  AppContractsIndexRoute: AppContractsIndexRoute,
  AppCostsIndexRoute: AppCostsIndexRoute,
  AppDocumentsIndexRoute: AppDocumentsIndexRoute,
  AppListsIndexRoute: AppListsIndexRoute,
  AppLogbookIndexRoute: AppLogbookIndexRoute,
  AppManualIndexRoute: AppManualIndexRoute,
  AppPeopleIndexRoute: AppPeopleIndexRoute,
  AppPlanningIndexRoute: AppPlanningIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppPropertiesIndexRoute: AppPropertiesIndexRoute,
  AppTasksIndexRoute: AppTasksIndexRoute,
  AppVaultIndexRoute: AppVaultIndexRoute,
  AppAssetsIdChar123TabChar125Route: AppAssetsIdChar123TabChar125Route,
  AppCalendarEventsIdRoute: AppCalendarEventsIdRoute,
  AppContractsIdChar123TabChar125Route: AppContractsIdChar123TabChar125Route,
  AppListsTemplatesIdRoute: AppListsTemplatesIdRoute,
  AppPeopleIdChar123TabChar125Route: AppPeopleIdChar123TabChar125Route,
  AppProjectsIdChar123TabChar125Route: AppProjectsIdChar123TabChar125Route,
  AppPropertiesIdChar123TabChar125Route: AppPropertiesIdChar123TabChar125Route,
  AppTasksSeriesIdRoute: AppTasksSeriesIdRoute,
  AppListsTemplatesIndexRoute: AppListsTemplatesIndexRoute,
  AppPropertiesIdZonesZoneIdRoute: AppPropertiesIdZonesZoneIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  InviteTokenRoute: InviteTokenRoute,
  STokenRoute: STokenRoute,
  SetupPasskeyRoute: SetupPasskeyRoute,
  SignInVerifyRoute: SignInVerifyRoute,
  SignInIndexRoute: SignInIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
